import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { CustomBreakpointNames } from '../../services/breakpoints.service';
import { LayoutService } from '../../services/layout.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit, OnDestroy {

  public links: any[] = [{ name: 'Edit Profile', icon: 'edit', url: 'profile' }, { name: 'Password & Security', icon: 'security', url: 'security' }];
  public activeLink = this.links[0].name
  public isSmall: boolean = false;

  private layout$: Subscription;
  private user$: Subscription;

  public userID: string | number;

  constructor(
    private authService: AuthService,
    private layoutService: LayoutService,
    private router: Router
  ) { }

  ngOnInit() {
    this.user$ = this.authService.currentUser.pipe().subscribe(res => {
      let user;
      if (res !== null) {
        user = res
      } else {
        user = JSON.parse(localStorage.getItem('currentUser'))
      }

      this.userID = user !== null ? user.id : null

      this.userID != null ? this.router.navigate(['home/account/profile', this.userID]) : () => { }
    })

    this.layout$ = this.layoutService.subscribeToLayoutChanges().subscribe(observerResponse => {
      // You will have all matched breakpoints in observerResponse

      if (this.layoutService.isBreakpointActive(CustomBreakpointNames.medium)) {
        this.isSmall = true
      } else if (this.layoutService.isBreakpointActive(CustomBreakpointNames.mediumToLarge)) {
        this.isSmall = false
      }
    });


  }

  ngOnDestroy() {
    if (this.layout$) this.layout$.unsubscribe()
    if (this.user$) this.user$.unsubscribe();
  }

}
